import { render, staticRenderFns } from "./NotificationBanner.vue?vue&type=template&id=3419afe6"
import script from "./NotificationBanner.vue?vue&type=script&lang=js"
export * from "./NotificationBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports